module.exports = __webpack_public_path__ + "img/Weapon_216.e0f58bc1.png";